import { render, staticRenderFns } from "./EitiaHome.vue?vue&type=template&id=2eda8eee&scoped=true&lang=html&"
import script from "./EitiaHome.vue?vue&type=script&lang=js&"
export * from "./EitiaHome.vue?vue&type=script&lang=js&"
import style0 from "./EitiaHome.vue?vue&type=style&index=0&id=2eda8eee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eda8eee",
  null
  
)

export default component.exports